import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { FileDown } from "lucide-react";
import { toast } from "sonner";

export const ExportPdfButton = ({ resource, params = {}, label = "Esporta PDF" }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const r = await api.get(`/export/${resource}`, { params, responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${resource}_${!params.company || params.company === "all" ? "consolidato" : params.company}${params.mese ? "_" + params.mese : ""}.pdf`;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
    } catch (e) {
      let msg = "Errore durante l'esportazione PDF";
      try { msg = JSON.parse(await e.response.data.text()).detail || msg; } catch {}
      toast.error(msg);
    }
    setBusy(false);
  };
  return (
    <Button size="sm" variant="outline" className="h-8 gap-1" onClick={run} disabled={busy}
            data-testid={`export-pdf-${resource}`}>
      <FileDown className="w-4 h-4" />{busy ? "Esporto…" : label}
    </Button>
  );
};
